import _regeneratorRuntime from "/Users/mikefree/Desktop/strata-2019/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/mikefree/Desktop/strata-2019/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _taggedTemplateLiteral from "/Users/mikefree/Desktop/strata-2019/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["# Utilities"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral([" In the code section above (click to the left of the chart to view it), circles are added to the screen, and their positions are iteratively updated in each step in the simulation (see <code>triggerSimulation</code> below to see how the speed is adjusted). \n\nOriginal Beeswarm code based on [this block](https://bl.ocks.org/mbostock/6526445e2b44303eebf21da3b6627320)."], [" In the code section above (click to the left of the chart to view it), circles are added to the screen, and their positions are iteratively updated in each step in the simulation (see <code>triggerSimulation</code> below to see how the speed is adjusted). \\n\nOriginal Beeswarm code based on [this block](https://bl.ocks.org/mbostock/6526445e2b44303eebf21da3b6627320)."]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["<form><button name=button>Click to run the simulation"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([" While the range of the values and some signal of the central tendencies are visible, this representation yields little information. As an alternative, the <code>y</code> position of each element can be shifted to reveal any overlapping points, yielding a **Beeswarm plot** \n\nThe complexity required to compute this layout should not be overlooked. The code below uses D3's [Force Directed Layout](https://github.com/d3/d3-force), which applies a simulation of physical forces on particles to achieve the desired layout.\n"], [" While the range of the values and some signal of the central tendencies are visible, this representation yields little information. As an alternative, the <code>y</code> position of each element can be shifted to reveal any overlapping points, yielding a **Beeswarm plot** \\n\nThe complexity required to compute this layout should not be overlooked. The code below uses D3's [Force Directed Layout](https://github.com/d3/d3-force), which applies a simulation of physical forces on particles to achieve the desired layout.\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["# The Simulation Behind Beeswarm Plots\n<a href=\"https://flowingdata.com/charttype/beeswarm/\" target=\"_blank\">Beeswarm plots</a> provide a layout for representing the distribution of a **single continuous variable**. Using a _position encoding_ of a single continous variable yields a one-dimensional scatterplot (or _dot plot_) (below), which is unable to <a href=\"https://research.tableau.com/sites/default/files/p110-mackinlay.pdf\" target=\"_blank\">express</a> all the observations (because of _occlusion_). "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// URL: https://observablehq.com/@mkfreeman/the-simulation-behind-beeswarm-plots
// Title: The Simulation Behind Beeswarm Plots
// Author: Michael Freeman (@mkfreeman)
// Version: 372
// Runtime version: 1
var m0 = {
  id: "fee52aa43b564f03@372",
  variables: [{
    inputs: ["md"],
    value: function value(md) {
      return md(_templateObject());
    }
  }, {
    name: "dot_density",
    inputs: ["settings", "d3", "DOM", "data"],
    value: function value(settings, d3, DOM, data) {
      var fullWidth = settings.width + settings.margin.left + settings.margin.right;
      var svg = d3.select(DOM.svg(fullWidth, 100));
      var x = d3.scaleLinear().rangeRound([0, settings.width]).domain(d3.extent(data, function (d) {
        return +d.value;
      }));
      var g = svg.append("g").attr("transform", "translate(" + settings.margin.left + "," + settings.margin.top + ")");
      svg.append("g").attr("class", "axis axis--x").attr("transform", "translate(" + settings.margin.left + "," + 70 + ")").call(d3.axisBottom(x));
      var circles = g.selectAll("circle").data(data);
      circles.enter().append("circle").attr("cx", function (d) {
        return x(d.value);
      }).attr("cy", function (d) {
        return 0;
      }).attr("r", 10).attr("fill", function (d) {
        return d.color;
      }).style("opacity", .3);
      return svg.node();
    }
  }, {
    inputs: ["md"],
    value: function value(md) {
      return md(_templateObject2());
    }
  }, {
    name: "viewof button",
    inputs: ["html", "triggerSimulation"],
    value: function value(html, triggerSimulation) {
      var form = html(_templateObject3());

      form.button.onclick = function (event) {
        event.preventDefault(); // Don’t submit the form.

        console.log('click');
        triggerSimulation();
      };

      return form;
    }
  }, {
    name: "button",
    inputs: ["Generators", "viewof button"],
    value: function value(G, _) {
      return G.input(_);
    }
  }, {
    name: "chart",
    inputs: ["settings", "d3", "DOM", "data"],
    value: function value(settings, d3, DOM, data) {
      settings.numSims = 0;
      settings.delay = settings.initialDelay;
      var fullWidth = settings.width + settings.margin.left + settings.margin.right,
          fullHeight = settings.height + settings.margin.top + settings.margin.bottom;
      var svg = d3.select(DOM.svg(fullWidth, fullHeight));
      var x = d3.scaleLinear().rangeRound([0, settings.width]).domain(d3.extent(data, function (d) {
        return +d.value;
      }));
      var g = svg.append("g").attr("transform", "translate(" + settings.margin.left + "," + settings.margin.top + ")");
      var simulation = d3.forceSimulation(data).force("x", d3.forceX(function (d) {
        return x(d.value);
      }).strength(1)).force("y", d3.forceY(settings.height / 2)).force("collide", d3.forceCollide(8)).stop();
      svg.append("g").attr("class", "axis axis--x").attr("transform", "translate(" + settings.margin.left + "," + settings.height + ")").call(d3.axisBottom(x));
      var circles = g.selectAll("circle").data(data);
      circles.enter().append("circle").attr("cx", function (d) {
        return x(d.value);
      }).attr("cy", function (d) {
        return settings.height / 2;
      }).attr("r", 10).attr("fill", function (d) {
        return d.color;
      }).style("opacity", .3);

      svg.node().update = function () {
        simulation.tick();
        g.selectAll("circle").data(data).transition().duration(settings.delay).ease(d3.easeLinear).attr("cx", function (d) {
          return d.x;
        }).attr("cy", function (d) {
          return d.y;
        });
      };

      return svg.node();
    }
  }, {
    inputs: ["md"],
    value: function value(md) {
      return md(_templateObject4());
    }
  }, {
    inputs: ["md"],
    value: function value(md) {
      return md(_templateObject5());
    }
  }, {
    name: "triggerSimulation",
    inputs: ["settings", "chart"],
    value: function value(settings, chart) {
      return function triggerSimulation() {
        if (settings.numSims > settings.maxSims) return;
        var delay = settings.numSims == 0 ? 0 : settings.delay;
        setTimeout(function () {
          settings.delay = settings.delay * settings.speedDecay;
          chart.update();
          settings.numSims++;
          triggerSimulation(); // oh no, recursion!
        }, delay);
      };
    }
  }, {
    name: "data",
    inputs: ["d3"],
    value: function () {
      var _value = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(d3) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return d3.csv("https://raw.githubusercontent.com/mkfreeman/binary-predictions/master/public/data/cancer_data.csv").then(function (data) {
                  data.forEach(function (d) {
                    d.value = +d.worst_concave_points, d.color = +d.outcome === 0 ? "blue" : "red";
                  });
                  return data;
                });

              case 2:
                _context.t0 = function (d) {
                  return d.value >= 0 & d.value < .4;
                };

                return _context.abrupt("return", _context.sent.filter(_context.t0));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function value(_x) {
        return _value.apply(this, arguments);
      }

      return value;
    }()
  }, {
    name: "settings",
    value: function value() {
      return {
        margin: {
          top: 50,
          right: 40,
          bottom: 50,
          left: 40
        },
        height: 500,
        width: 900,
        initialDelay: 1000,
        numSims: 0,
        speedDecay: .9,
        maxSims: 2000
      };
    }
  }, {
    name: "d3",
    inputs: ["require"],
    value: function value(require) {
      return require("d3@5");
    }
  }]
};
var notebook = {
  id: "fee52aa43b564f03@372",
  modules: [m0]
};
export default notebook;